// extracted by mini-css-extract-plugin
module.exports = {"wrap":"s_wrap__35Y3g","buttonsWrap":"s_buttonsWrap__1fOCa","button":"s_button__LPsuM"};